import {Fragment, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import {CardGroup, Message} from 'semantic-ui-react';
import ConsultPackage from './consult-package';
import PaymentModal from './payment-modal';
import {SuccessModal} from '../shared/modals';
import {createOrderByConsultPackage} from '../../redux/actions/order';
import CreateOrderModal from './create-order-modal';

function ConsultPackagesList(props) {
  const {consultPackages} = props;
  const [selectedConsultPackage, setSelectedConsultPackage] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [order, setOrder] = useState(null);

  const history = useHistory();

  async function handleConfirm(props, codeText) {
    try {
      setErrorMessage('');
      const {payload: order} = await props.createOrderByConsultPackage(selectedConsultPackage.id, codeText);
      setOrder(order);
      setShowPaymentModal(true);
    } catch (e) {
      setErrorMessage('متاسفانه در حال حاضر خرید این بسته مشاوره مقدور نمی‌باشد.');
    }
    setShowConfirmModal(false);
  }

  function handleSuccessConfirm() {
    setShowSuccessModal(false);
    history.push('/report');
  }

  function handleClickOnConsultPackageButton(consultPackage) {
    setShowConfirmModal(true);
    setSelectedConsultPackage(consultPackage);
  }

  const successMessage = selectedConsultPackage.name ?
    ` '${selectedConsultPackage.name}'
   شما با کسر ${selectedConsultPackage.price.toLocaleString()}
   ریال از موجودی شما با موفقیت فعال شد.` :
    '';

  return (
    <Fragment>
      {errorMessage && <Message negative content={errorMessage} className='text-center'/>}
      {showSuccessModal && <Message positive content={successMessage} className='text-center'/>}

      <CardGroup stackable centered doubling itemsPerRow={3}>
        {consultPackages.map(consultPackage => (
          <ConsultPackage
            key={consultPackage.id}
            consultPackage={consultPackage}
            onClick={handleClickOnConsultPackageButton.bind(null, consultPackage)}
          />
        ))}
      </CardGroup>

      {showConfirmModal && (
        <CreateOrderModal
          open={showConfirmModal}
          package={selectedConsultPackage}
          onCancel={setShowConfirmModal.bind(null, false)}
          onConfirm={handleConfirm.bind(null, props)}
        />
      )}

      {showPaymentModal && (
        <PaymentModal
          packageName={selectedConsultPackage.name}
          open={showPaymentModal}
          onClose={setShowPaymentModal.bind(null, false)}
          order={order}
        />
      )}

      {showSuccessModal && (
        <SuccessModal
          open={showSuccessModal}
          onConfirm={handleSuccessConfirm}
          onClose={setShowSuccessModal.bind(null, false)}
          size='small'
          message={successMessage}
        />
      )}
    </Fragment>
  );
}

ConsultPackagesList.propTypes = {
  consultPackages: PropTypes.arrayOf(PropTypes.object).isRequired,
  createOrderByConsultPackage: PropTypes.func.isRequired
};

export default connect(null, {createOrderByConsultPackage})(ConsultPackagesList);
